// src/components/layout/MainLayout.jsx - 修复版本
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../common/Header';
import Navigation from '../common/Navigation';
import ReceiptModal from '../common/ReceiptModal';

const MainLayout = () => {
  const [showReceipt, setShowReceipt] = useState(false);
  const [lastReceipt, setLastReceipt] = useState(null);

  const handleShowReceipt = (receipt) => {
    setLastReceipt(receipt);
    setShowReceipt(true);
  };

  return (
    <div className="h-screen flex flex-col bg-gradient-to-br from-gray-50 to-gray-100">
      {/* Header - 固定高度 */}
      <div className="flex-shrink-0">
        <Header />
      </div>
      
      {/* Navigation - 固定高度 */}
      <div className="flex-shrink-0">
        <Navigation />
      </div>
      
      {/* 主内容区 - 可滚动 */}
      <div className="flex-1 overflow-hidden">
        <div className="h-full max-w-7xl mx-auto px-4 py-6">
          {/* Outlet 会渲染子路由的组件 */}
          <Outlet context={{ onShowReceipt: handleShowReceipt }} />
        </div>
      </div>

      {showReceipt && (
        <ReceiptModal 
          receipt={lastReceipt}
          onClose={() => setShowReceipt(false)}
        />
      )}
    </div>
  );
};

export default MainLayout;